import Vue from "vue"
import moment from "moment-timezone";

Vue.filter("timeSince", (date, timezone = 'Europe/London') => {
    return moment.tz(date, timezone).fromNow();
    // return date;
    // let seconds = Math.floor((new Date(new Date().toLocaleString('sv-SE', {timeZone: timezone}).substr(0, 25)) - new Date(date)) / 1000);
    // if(UTC) {
    //     let now = new Date();
    //     let utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    //     let then = new Date(date)
    //     let utcThen = new Date(then.getTime() + then.getTimezoneOffset() * 60000);
    //     seconds = (utc-utcThen)/1000;
    // }
    // let interval = seconds / 31536000;
    // if (interval > 1) {
    //     return Math.floor(interval) + " years ago";
    // }
    // interval = seconds / 2592000;
    // if (interval > 1) {
    //     return Math.floor(interval) + " months ago";
    // }
    // interval = seconds / 86400;
    // if (interval > 1) {
    //     return Math.floor(interval) + " days ago";
    // }
    // interval = seconds / 3600;
    // if (interval > 1) {
    //     return Math.floor(interval) + " hours ago";
    // }
    // interval = seconds / 60;
    // if (interval > 1) {
    //     return Math.floor(interval) + " minutes ago";
    // }
    // return Math.floor(seconds) + " seconds ago";
})
